import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { SubscriptionBasedComponent } from '../subscription-helpers/subscription-based.component';
import { CreateBaseProjectUrlParams } from '../pages/projects/client-corner/create-view-base-project/create-base-project-url-params';

@Injectable({
  providedIn: 'root',
})
export class CreateBaseProjectUrlParamsService extends SubscriptionBasedComponent {
  public createBaseProjectUrlParamsEvent =
    new Subject<CreateBaseProjectUrlParams>();
  private createBaseProjectUrlParams: CreateBaseProjectUrlParams;

  constructor(private activatedRoute: ActivatedRoute) {
    super();

    this.addSubscription(this.activatedRoute.queryParams, (params) => {
      const createBaseProjectUrlParams: CreateBaseProjectUrlParams = {
        address: params['address'],
        company: params['company'],
        company_contact: params['company_contact'],
        era_id: params['era_id'],
      };

      this.createBaseProjectUrlParams = createBaseProjectUrlParams;
      this.createBaseProjectUrlParamsEvent.next(createBaseProjectUrlParams);
    });
  }

  public getCreateBaseProjectUrlParams(): CreateBaseProjectUrlParams {
    return this.createBaseProjectUrlParams;
  }
}
